import { elementScrollIntoView } from "seamless-scroll-polyfill";

const kitProfitLink = document.querySelector(".js-card-info__kit-profit");
if (kitProfitLink) initScrollingElements(kitProfitLink);

const readMoreLink = document.querySelector(".read-more__link");
if (readMoreLink) initScrollingElements(readMoreLink);

function initScrollingElements(element) {
    const hash = element.getAttribute("href")?.replace("#", "");
    const block = hash ? document.getElementById(hash) : null;

    element.addEventListener("click", (e) => {
        e.preventDefault();

        if (block) {
            elementScrollIntoView(block, { behavior: "smooth", block: "start" });
        }
    });
}
